export const handleDetailKeyToString = (key: string, cycle?: string) => {
  switch (key) {
    case "recruit":
      return "Recruit";
    case "sales":
      return "Sales";
    case "book":
      return "Book";
    case "bonusPromo":
      return cycle === "c3" ? "Bonus Income" : "Bonus Promo";
    case "bonusBBC":
      return "Bonus BBC";
    case "bonusEvents":
      return "Bonus Events";
    case "bonusBF":
      return "Bonus BF";
    case "bonusGX":
      return "Bonus GX";
    case "attend":
      return "Attend";
    case "penalty":
      return "Penalty";
    case "penaltyNotes":
      return "Penalty Notes";
    case "callout":
      return "Callout";
    case "calloutNotes":
      return "Callout Notes";
    case "total":
      return "Total";
    default:
      return key;
  }
};
